export default __webpack_public_path__ + "static/media/1_0080.43592d5a.webp";